import React, {Component} from 'react';
import {Row, Col,} from "react-bootstrap";
import moment from 'moment'
import SprawdzKonfiguraceSearchbox from "./components/componentsRozklad/SprawdzKonfiguraceSearchbox";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import CennikBiletowService from "../../biletyConfig/cenyBiletow/CennikBiletowService";
import SprawdzKonfiguraceCennikiTable from "./components/componentsCenniki/SprawdzKonfiguraceCennikiTable";

export default class SprawdzKonfiguracjeZakladkaCennik extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: DateAndTimeFormat.formatYYYYMMDD(moment()),
            koniec: DateAndTimeFormat.formatYYYYMMDD(moment()),
            params: {
                dataOd: null,
                dataDo: null,
            },
            konfiguracjaStart: null,
            konfiguracjaKoniec: null,
            rekordy: [],
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        this.ustawPoczatkoweWartosci(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawPoczatkoweWartosci(nextprops)
    }

    ustawPoczatkoweWartosci(props) {
        this.setState({
            start: props.start,
            koniec: props.koniec,
            konfiguracjaStart: props.start,
            konfiguracjaKoniec: props.koniec,
        })

        this.onClickSzukaj(
            {
                dataOd: props.start,
                dataDo:props.koniec,
            }
        )
    }

    onClickSzukaj(params) {
        this.setState({params: params, start: params.dataOd, koniec: params.dataDo})
        CennikBiletowService.pobierzSprawdzenieKonfiguracjiCennikow(params.dataOd, params.dataDo).then(function (response) {
            if (response) {
                if (response.status < 300) {
                    this.setState({rekordy: response.data})
                }
            }
        }.bind(this))
    }

    render() {

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <SprawdzKonfiguraceSearchbox start={this.state.start} koniec={this.state.koniec} trasy={[]}
                                                     handleClickSzukaj={this.onClickSzukaj} ukryjTrasy={true}
                        />
                    </Col>
                    <Col xs={12}>
                        {
                            (Boolean(this.state.konfiguracjaStart) && Boolean(this.state.konfiguracjaKoniec)) ?
                                <div style={{margin: '5px 15px', color: 'grey', fontStyle: 'italic'}}>
                                    Obecnie zdefiniowany zakres w konfiguracji: od {this.state.konfiguracjaStart} do {this.state.konfiguracjaKoniec}
                                </div>
                                :
                                ''
                        }
                    </Col>
                    <Col sm={12}>
                        <SprawdzKonfiguraceCennikiTable data={this.state.rekordy} rodzajZnizki={this.state.rodzajZnizki}/>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/SprawdzKonfiguracjeZakladkaCennik.js